import { OverlayContainer, PrimaryButton, ReactIcons } from "@kalyzee/kalyzee-ui";
import React from "react";
import { MeetingShareContent } from "./MeetingShareContent";
import styles from "./ShareMeetingPopup.module.css";

export interface ShareMeetingPopupProps {
  visible: boolean;
  /** Short id of the meeting to share; also what the QR code encodes. */
  shortId?: string;
  /** Shown as the subtitle, to tell which meeting is being shared. */
  meetingName?: string;
  onClose: () => void;
}

/** Shares a meeting without having to join it — used by the meetings list. */
export const ShareMeetingPopup: React.FC<ShareMeetingPopupProps> = ({ visible, shortId, meetingName, onClose }) => {
  return (
    <OverlayContainer
      visible={visible}
      style={{ position: "fixed", inset: 0, zIndex: 1000 }}
      overlayStyle={{ padding: "1em" }}
      onClose={onClose}
      overlay={
        <div className={styles.card} onClick={(e) => e.stopPropagation()}>
          <PrimaryButton className={styles.closeBtn} onClick={onClose}>
            <ReactIcons.Close style={{ height: "0.8em" }} />
          </PrimaryButton>

          <div className={styles.header}>
            <h2 className={styles.title}>Partager le meeting</h2>
            {meetingName && <p className={styles.subtitle}>{meetingName}</p>}
          </div>

          <MeetingShareContent shortId={shortId} className={styles.content} />
        </div>
      }
    />
  );
};
